<template>
    <b-modal ref="createPost" id="createPost" size="lg" @hide="onHide" @show="onShow" top :title="postTitle">
        <b-row v-if="ticketType == $t('actionTicket')" class="mt-1">
            <b-col style="text-align: left;font-weight: bold">
                <label>{{ $t('actionResponseText') }}</label>
            </b-col>
        </b-row>
        <b-row v-else class="mt-1">
            <b-col style="text-align: left;font-weight: bold">
                <label>{{ $t('auditResponseText') }}</label>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-textarea v-model="text" :rows="3" :max-rows="6" :class="{'is-invalid': errors.text}" @focus.native="errors.text = false"/>
            </b-col>
        </b-row>
        <b-row v-if="replyType === 'negative'" class="my-1">
            <b-col style="text-align: left;font-weight: bold">
                <label>{{ $t('extendedDate') }}</label>
            </b-col>
        </b-row>
        <b-row v-if="replyType === 'negative'">
            <b-col style="text-align: left;">
                <el-date-picker
                    v-model="extendedDate"
                    type="date"
                    :readonly="false"
                    format="dd/MM/yyyy"
                    style="width: 100%; align-self: center"
                    :class="{'is-invalid': errors.text}"
                    :placeholder="$t('chooseDatePlaceholder')"
                    :picker-options="extendedDateOptions"
                />
            </b-col>
        </b-row>
        <b-row class="my-1">
            <b-col style="text-align: left;font-weight: bold">
                <label>{{ $t('additionalFiles') }}</label>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-row align-h="start" no-gutters>
                    <template v-if="postDocuments.length">
                        <template v-for="(file, index) in postDocuments">
                            <b-col cols="1" v-bind:key="`upload-${index}`" style="text-align: center">
                                <upload 
                                    fileCategory="audit-post"
                                    :showUpload="false" 
                                    :showDownload="false" 
                                    :reactive-id="`${reactiveId}-${file.uuid}-${index}`"
                                    :deleteFromDB="true"
                                    :dataId="file.id"
                                    @onremove="handleRemoving($event, file)"/>
                                <div style="font-size: 12px; text-align: center">{{file.filename | textToShortText}}</div>
                            </b-col>
                        </template>
                    </template>
                    <b-col cols="1" style="text-align: left">
                        <upload-regular 
                            fileCategory="audit-post"
                            @onupload="onupload"/>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button @click="type === 'updatePost' ? update() : insert()" variant="Primary">{{ $t('save') }}</b-button>
            <b-button @click="closeModal(true)" variant="Danger">{{ $t('cancel') }}</b-button>
        </div>
    </b-modal>
</template>

<script>
import uuid from 'uuid/v4';
import Upload from '../../components/Upload';
import UploadRegular from '../../components/UploadRegular';
import _ from 'lodash';

export default {
    name: 'createPost',
    components: {UploadRegular, Upload},
    data() {
        return {
            eventId: null,
            compId: uuid(),
            text: null,
            reactiveId: uuid(),
            siteId: null,
            type: null,
            ticket: null,
            ticketId: null,
            postId: null,
            postDocuments: [],
            replyType: null,
            ticketType: null,
            extendedDate: new Date(),
            extendedDateCheck: null,
            errors: {
                text: false,
                extendedDate: false
            },
            extendedDateOptions:{}
        };
    },
    methods: {
        onupload(event) {
            this.postDocuments.push({
                id: event.id,
                filename: event.filename,
                uuid: event.fileId,
                fileUrl: event.fileUrl
            });
        },
        handleRemoving(event, file) {
            this.postDocuments =_.remove(this.postDocuments, function(nFile){
                return _.get(file, 'uuid') != _.get(nFile, 'uuid') || _.get(file, 'fileId') != _.get(nFile, 'fileId');
            });
        },
        onHide(event){
            if(_.get(event, 'trigger') != null){
                this.closeModal(true);
            }
        },
        closeModal(deleteFiles=false) {
            if(deleteFiles){
                let fileIds = _.map(_.filter(this.postDocuments, docs=> _.includes(Object.keys(docs), 'id')), 'id');
                this.axios.post('/deleteFilesFromAWS',{files:fileIds}).then(()=>{
                    this.$refs.createPost.hide();
                });
            }
            else{
                this.$refs.createPost.hide();
            }
        },
        insert() {
            if (this.isValidInsertion()) {
                let post = {
                    answerText: this.text,
                    documentIds: this.postDocuments.map(document => {
                        return document.uuid;
                    })
                };
                if (this.replyType === 'negative') {
                    post.extendedDate = this.createUTCDate(
                        this.extendedDate.getFullYear(),
                        this.extendedDate.getMonth(),
                        this.extendedDate.getDate()
                    );
                } else {
                    let extendedDates = _.map(this.ticket.posts, 'extendedDate');
                    post.extendedDate = extendedDates[Object.keys(extendedDates).length - 1];
                }
                return this.axios
                    .post(`/${this.siteId}/audits/${this.ticketId}`, {
                        ...post,
                        ticketType: this.ticket.ticketType,
                        title: (this.ticketType == 'Action') ? this.ticket.textInput : this.ticket.scope,
                        isExtendedDateChanged:
                            this.extendedDate === this.extendedDateCheck ? false : true
                    })
                    .then(({data}) => {
                        this.postId = data.id;
                        this.$eventHub.$emit(this.$store.state.modal.eventId, data);
                        this.closeModal(false);
                    });
            } else {
                this.$toasted.error(this.$t('missingError'));
            }
        },
        isValidInsertion() {
            this.errors.text = !(this.text && this.text.length);
            if (this.replyType === 'negative') {
                this.errors.extendedDate = !this.extendedDate;
            }
            let validation = true;
            for (let key in this.errors) {
                validation &= !this.errors[key];
            }
            return validation;
        },
        update() {
            let post = {
                answerText: this.text,
                documents: this.postDocuments
            };
            if (this.replyType === 'negative') {
                post.extendedDate = this.createUTCDate(
                    this.extendedDate.getFullYear(),
                    this.extendedDate.getMonth(),
                    this.extendedDate.getDate()
                );
            } else {
                let extendedDates = _.map(this.ticket.posts, 'extendedDate');
                post.extendedDate = extendedDates[Object.keys(extendedDates).length - 1];
            }
            this.postId = this.$store.state.modal.payload.post.id;
            return this.axios
                .put(`/${this.siteId}/audits/${this.ticketId}/post/${this.postId}`, post)
                .then(({data}) => {
                    this.$eventHub.$emit(this.$store.state.modal.eventId, data);
                    this.closeModal(false);
                });
        },
        onShow() {
            Object.assign(this.$data, this.$options.data());
            this.eventId = this.$store.state.modal.eventId;
            this.siteId = this.$store.state.modal.payload.siteId;
            this.ticketId = this.$store.state.modal.payload.ticketId;
            this.ticket = this.$store.state.modal.payload.ticket;
            this.type = this.$store.state.modal.type;
            this.replyType = this.$store.state.modal.payload.replyType;
            this.ticketType = this.$store.state.modal.payload.ticket.ticketType;
            let extendedDates = _.map(this.ticket.posts, 'extendedDate');
            this.extendedDate = extendedDates[Object.keys(extendedDates).length - 1]
                ? extendedDates[Object.keys(extendedDates).length - 1]
                : this.ticket.expectedDate;
            this.extendedDateCheck = this.extendedDate;
            if (this.type === 'updatePost') {
                let post = this.$store.state.modal.payload.post;
                this.text = post.answerText;
                this.extendedDate = post.extendedDate ? post.extendedDate.split('T')[0]: null;
                this.postDocuments = _.cloneDeep(post.documents);
                this.postId = post.id;
            }
            this.extendedDateOptions = {
                disabledDate: (time) => {
                    return time.getTime() < new Date(this.ticket.expectedDate);
                }
            }
        }
    },
    computed: {
        postTitle() {
            if (this.replyType === 'negative') {
                return this.type === 'updatePost'
                    ? this.$t('updateNegativeControl')
                    : this.$t('createNegativeControl');
            } else {
                return this.type === 'updatePost'
                    ? this.$t('updateResponse')
                    : this.$t('createResponse');
            }
        }
    }
};
</script>

<style scoped>
</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "createNegativeControl": "Olumsuz Kontrol Oluştur",
            "updateNegativeControl": "Olumsuz Kontrol Düzenle",
            "createResponse": "Yanıt Oluştur",
            "updateResponse": "Yanıt Güncelle",
            "additionalFiles": "Ek Dosyalar",
            "extendedDate": "Uzatılmış Gerçekleştirme Tarihi",
            "auditResponseText": "Alınan Aksiyon",
            "actionResponseText": "Tamamlanan doküman bilgisi ve gerekçe",
            "auditTicket":"Denetim",
            "actionTicket":"Aksiyon"
        },
        "en": {
            "createNegativeControl": "Create Negative Control",
            "updateNegativeControl": "Update Negative Control",
            "createResponse": "Add Response",
            "updateResponse": "Update Response",
            "additionalFiles": "Additional Files",
            "extendedDate": "Extended Completion Date",
            "auditResponseText": "Action taken",
            "actionResponseText": "Complited document and reason",
            "auditTicket":"Audit",
            "actionTicket":"Action"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/components/modals/CreatePost.vue